import { Grid, TextField } from "@material-ui/core";
import { forwardRef, useImperativeHandle } from "react";
import { useForm, Controller } from "react-hook-form";

const AdminUserForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, loading = false } = props;

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: defaultValues ?? null,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
    isSubmitSuccessful: () => isSubmitSuccessful,
  }));

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12}>
          <Controller
            name='first_name'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='نام'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.first_name}
                helperText={errors.first_name && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='last_name'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='نام خانوادگی'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.last_name}
                helperText={errors.last_name && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='phone_number'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='شماره همراه'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.phone_number}
                helperText={errors.phone_number && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='username'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='نام کاربری'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.username}
                helperText={errors.username && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='work_title'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='عنوان محل کار'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.work_title}
                helperText={errors.work_title && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='work_address'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='آدرس محل کار'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.work_address}
                helperText={errors.work_address && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='work_number'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(e) => field.onChange({ ...e, target: { value: e?.target?.value?.toEnglishDigits() } })}
                value={field?.value?.toPersianDigits()}
                label='شماره تماس محل کار'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.work_number}
                helperText={errors.work_number && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Controller
            name='username'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='نام کاربری'
                size='small'
                margin='dense'
                variant='outlined'
                disabled={loading}
                error={errors.username}
                helperText={errors.username && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid> */}
      </Grid>
    </form>
  );
});

export default AdminUserForm;
